var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("list-item", {
    attrs: {
      booking: _vm.booking,
      link: { name: "requests.show", params: { id: _vm.booking.id } },
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [
            _c("span", [_vm._v(_vm._s(_vm.booking.name))]),
            _vm._v(" "),
            _vm.bookingIsVetting
              ? _c("span", { staticClass: "small" }, [_vm._v("– (Pending)")])
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "hero",
        fn: function () {
          return [_vm._v("View")]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }